import { getPageSection } from '../utils/getPageSection'
import { getLangFromUrl } from '../utils/getLangFromUrl'
;(() => {
  window.getDevice = () => {
    const userAgent = navigator.userAgent

    if (/Android/i.exec(userAgent)) {
      return 'android'
    }

    if (/iPhone|iPad|iPod/i.exec(userAgent)) {
      return 'ios'
    }

    if (/Mobi/i.exec(userAgent)) {
      return 'mobile'
    }

    return 'web'
  }
  window.getPageSection = getPageSection()
  window.getLangUrl = getLangFromUrl()
})()
